import { Navigate } from 'react-router-dom'

const RedirectToNewNpsPage = ({ path }: { path: string }) => <Navigate to={path} />

export default RedirectToNewNpsPage
